import { ResourcesStorage } from './ResourcesStorage';

const THREE = require('three');

const LoadSingleTexture = (id, url, critical, doThat, store = true, storage = null) => {
    const _storage = storage || ResourcesStorage.instance();

    return new Promise((resolve, reject) => {
        if (!doThat) {
            resolve(doThat);

            return;
        }

        const textureLoader = new THREE.TextureLoader();

        textureLoader.load(url,
            (texture) => {
                if (store) _storage.add(id || url, texture);
                resolve(texture);
            },
            undefined,
            () => {
                if (store) _storage.setNotLoaded(id || url);
                console.warn(`Resource ${id} (${url}) loading failed`);

                if (critical) {
                    reject();

                    return;
                }
                resolve(null);
            });
    });
};

const LoadSingleTextureFunction = (
    id, url, critical, type, store, storage
) => (doThat) => LoadSingleTexture(id, url, critical, doThat, type, store, storage);

export { LoadSingleTexture, LoadSingleTextureFunction };
export default LoadSingleTexture;
